import { Interval } from 'luxon';

import { EntityType } from 'common/types';

import { AvgBasketSizeInsight, SalesInsight } from './types';

export const getBaseUrl = (entityType: EntityType, entityId: string) => {
  return `/merchant-analytics-api/${entityType}s/${entityId}/insights`;
};

export const SIMPLE_DATE_FORMAT = 'yyyy-MM-dd';

export const getDateRangeForApiCall = (interval: Interval) => {
  // It's a common practice to use half-open interval for API call in order to provide a consistent way of specifying the range.
  // For example, a query for data from January 1, 2023, to January 31, 2023, would use the interval [2023-01-01, 2023-02-01).
  return {
    start_date: interval.start.toFormat(SIMPLE_DATE_FORMAT),
    end_date: interval.end.plus({ day: 1 }).toFormat(SIMPLE_DATE_FORMAT),
  };
};

export function getSales(salesInsight: SalesInsight, withVAT: boolean): number;
export function getSales(salesInsight: null | undefined, withVAT: boolean): undefined;
export function getSales(salesInsight: SalesInsight | null | undefined, withVAT: boolean): number | undefined;

export function getSales(salesInsight: SalesInsight | null | undefined, withVAT: boolean = false): number | undefined {
  if (!salesInsight) {
    return;
  }

  return withVAT ? salesInsight.salesWithVat : salesInsight.salesNoVat;
}

export function getBasketSize(basketSizeInsight: AvgBasketSizeInsight, withVAT: boolean): number;
export function getBasketSize(basketSizeInsight: null | undefined, withVAT: boolean): undefined;
export function getBasketSize(
  basketSizeInsight: AvgBasketSizeInsight | null | undefined,
  withVAT: boolean,
): number | undefined;
export function getBasketSize(
  basketSizeInsight: AvgBasketSizeInsight | null | undefined,
  withVAT: boolean = false,
): number | undefined {
  if (!basketSizeInsight) {
    return;
  }

  return withVAT ? basketSizeInsight.avgBasketSizeWithVat : basketSizeInsight.avgBasketSizeNoVat;
}
